import React from 'react';
import { TooltipWrapper } from '../../utils/Utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Tooltip = (props: any): React.ReactElement => {
  const { payload, separator, formatter, itemStyle, itemSorter } = props;

  if (payload && payload.length) {
    const listStyle = { padding: 0, margin: 0 };
    const entry = payload[0].payload;
    const [testType, metricLabel] = entry.label.split(':');
    const finalItemStyle = {
      display: 'block',
      color: 'var(--color-text)',
      ...itemStyle,
    };

    return (
      <TooltipWrapper>
        <ul className='recharts-tooltip-item-list' style={listStyle}>
          <li className='recharts-tooltip-item' style={finalItemStyle}>
            {testType}
          </li>
          <li className='recharts-tooltip-item' style={finalItemStyle}>
            {metricLabel}
          </li>
          <li className='recharts-tooltip-item' style={finalItemStyle}>
            ZScore : {entry.zscore}
          </li>
        </ul>
      </TooltipWrapper>
    );
  }

  return null;
};
